module.exports = __webpack_public_path__ + "static/ryoko2024-df4414db2baadcbb95f3df35070b4971.jpg";